module.exports = __webpack_public_path__ + "media/images/punjabi-matrimony-banner-8252b38341b73828b6342cebfffd39bc.jpg";